module.exports = __webpack_public_path__ + "media/1923-2020.d2d9373b.mp4";